<hr class="w-75 mx-auto"  style="color: var(--primary-color)">

<div class="container px-4 py-5" id="featured-3">
  <div class="row g-4 py-5 row-cols-1 row-cols-lg-2">
    <div class="feature col">

      <h3 class="fs-3 fw-bold" style="color: var(--primary-color)">Nuestra Política de calidad</h3>
      <p class="fs-5 text-secondary">Somos un equipo humano adaptable, competente, con experiencia y vanguardista; que brinda servicios médicos ambulatorios integrales, cercanos a nuestros usuarios; comprometidos con: su bienestar, las normativas, la mejora continua, la excelencia en el servicio; manteniendo altos estándares sanitarios, sociales y medioambientales.</p>
      <div class="container text-center mt-4">
        <img ngSrc="/assets/img/aboutUs/sgs.svg" class="" width="200" height="200" alt="">
      </div>

    </div>

    <div class="feature col">

      <h3 class="fs-3 fw-bold" style="color: var(--primary-color)">Objetivos de la calidad</h3>
<!--      <p class="fs-5 text-secondary"></p>-->
      <ul>
        <li class="fs-5 text-secondary" *ngFor="let objetivo of objetivos">{{objetivo.objetivo}}</li>
      </ul>
    </div>

  </div>
</div>
